import {Injectable} from '@angular/core';
import {CrudService} from '../crud/crud.service';
import {Spring} from '../spring/spring';

@Injectable({
  providedIn: 'root'
})
export class CpfacturService {

  constructor(private crud: CrudService,
              private spring: Spring) {
  }


  lecturaXML(cpfactur: any) {
    return this.crud.post(`${this.spring.CPFACTUR_XML}`, cpfactur);
  }

  postCpfacturExtranjera(cpfactur: any) {
    return this.crud.post(`${this.spring.CPFACTUR_CPFACTUR_EXTRANJERA}`, cpfactur);
  }

  getListCpfacturByIdgenral(idgenral: number) {
    return this.crud.get(`${this.spring.CPFACTUR_GET_LIST_BY_IDGENRAL}${idgenral}`)
  }

  deleteCpfactur(idfactur: number) {
    return this.crud.delete(`${this.spring.CPFACTUR_DELETE}${idfactur}`);
  }

  postFilterCpfactur(search: any) {
    return this.crud.post(`${this.spring.CPFACTUR_FILTER}`, search)
  }

  setCpfacturUsuarioValida(idfactur: number, accion: string) {
    return this.crud.getText(`${this.spring.CPFACTUR_SET_USUARIO_VALIDA}${idfactur}&${accion}`)
  }

  getListCpfacturSaldoPendiente(idpersonLocal: number, idprovee: number, idtipmonFacturas: number) {
    return this.crud.get(`${this.spring.CPFACTUR_GET_LIST_SALDO_PENDIENTE}${idpersonLocal}&${idprovee}&${idtipmonFacturas}`);
  }

  getListCpfacturSaldoPendienteAPagar(idpersonLocal: number, idprovee: number, idtipmonFacturas: number, idmovimi: number) {
    return this.crud.get(`${this.spring.CPFACTUR_GET_LIST_SALDO_PENDIENTE_A_PAGAR}${idpersonLocal}&${idprovee}&${idtipmonFacturas}&${idmovimi}`);
  }

  getListCpfacturAplicadas(idmovimi: number) {
    return this.crud.get(`${this.spring.CPFACTUR_GET_LIST_APLICADAS}${idmovimi}`);
  }


}
